import { render, staticRenderFns } from "./SampleItem.vue?vue&type=template&id=6af6620a&scoped=true&"
import script from "./SampleItem.vue?vue&type=script&lang=js&"
export * from "./SampleItem.vue?vue&type=script&lang=js&"
import style0 from "./SampleItem.vue?vue&type=style&index=0&id=6af6620a&lang=stylus&scoped=true&"
import style1 from "./SampleItem.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6620a",
  null
  
)

export default component.exports